import React, { useEffect, useState } from "react";
import "./nuestro-parque.css";
import { getTarjetasInicio } from "../../config/services/strapi/home";
import { getNuestroParque } from "../../config/services/strapi/nuestro-parque";
import TextSkeleton from "../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../components/Skeleton/ImageSkeleton";
interface StrapiBlock {
  children: Array<{ text: string }>;
}

const DescripcionBlock = ({ block }: { block: StrapiBlock }) => {
  const fullText = block.children?.map((c) => c.text).join("") || "";
  if (!fullText.trim()) return null;

  const lineas = fullText.split("\n").filter((linea) => linea.trim() !== "");

  return (
    <>
      {lineas.map((linea) => {
        const esProximamente = linea.toLowerCase().includes("próximamente");
        const lineKey = `line-${linea.substring(0, 20)}`;

        if (esProximamente) {
          return (
            <div key={lineKey} className="contenedor-proximamente">
              <h4 className="titulo-proximamente-nuestro-parque">{linea}</h4>
            </div>
          );
        }
        return (
          <p key={lineKey} className="texto-descripcion-nuestro-parque">
            {linea}
          </p>
        );
      })}
    </>
  );
};

export default function NuestroParque() {
  const [heroData, setHeroData] = useState<any>(null);
  const [secciones, setSecciones] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function loadData() {
      try {
        const [tarjetas, dataParque] = await Promise.all([
          getTarjetasInicio(),
          getNuestroParque(),
        ]);
        if (isMounted) {
          const tarjetaHero = tarjetas.find((t: any) => t.titulo?.includes("NUESTRO PARQUE"));
          setHeroData(tarjetaHero);
          setSecciones(dataParque);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    loadData();
    return () => { isMounted = false; };
  }, []);

  const renderHeroTitle = () => {
    const texto = heroData?.titulo || "NUESTRO PARQUE";
    return texto.split(" ").map((word: string, i: number) => (
      <React.Fragment key={`${word}-${i}`}>
        {word} {i === 0 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <>
      <section className="section-nuestro-parque">
        <div className="section-inner-nuestro-parque">
          <div className="col-text-nuestro-parque nuestro-parque">
            {loading ? <TextSkeleton /> : <h1>{renderHeroTitle()}</h1>}
          </div>
          <div className="col-media-nuestro-parque">
            {loading ? (
              <ImageSkeleton className="h-full" />
            ) : (
              <div
                className="media-cover-nuestro-parque"
                style={{ backgroundImage: heroData?.portada?.url ? `url(${heroData.portada.url})` : "none" }}
              />
            )}
          </div>
        </div>
      </section>

      {(loading ? Array.from({ length: 2 }).map((_, index) => ({ id: `skeleton-${index}`, descripcion: null, portada: null, documentId: `skeleton-${index}` })) : secciones).map((item, index) => (
        <section key={item.id || `section-${item.documentId}`} className="section-principal-nuestro-parque">
          <div className={`contenedor-nuestro-parque ${index % 2 === 0 ? "" : "contenedor-nuestro-parque-reverse"}`}>
            <div className="columna-imagen-nuestro-parque">
              <div className="wrapper-imagen-nuestro-parque">
                {loading ? (
                  <ImageSkeleton className="h-full" />
                ) : (
                  <img src={item.portada?.url || ""} alt="Parque" className="imagen-adaptable-nuestro-parque" />
                )}
              </div>
            </div>
            <div className="columna-texto-nuestro-parque">
              {loading ? (
                <TextSkeleton />
              ) : (
                item.descripcion?.map((block: any, i: number) => (
                  <DescripcionBlock key={`block-${item.id}-${i}`} block={block} />
                ))
              )}
            </div>
          </div>
        </section>
      ))}
    </>
  );
}